import { render, staticRenderFns } from "./Manua.vue?vue&type=template&id=66845a07"
import script from "./Manua.vue?vue&type=script&lang=js"
export * from "./Manua.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports